export const GroupOneName = "group-1";
export const tintFormTagName = "tint-form";
export const FORM_ELEMENTS_TYPES = {
  SINGLE_LINE_TEXT: "single_line",
  NUMBER: "number",
  MULTI_LINE_TEXT: "multi_line",
  WEBSITE: "website",
  STAR_RATING: "star_rating",
  SINGLE_CHOICE: "single_choice",
  MULTIPLE_CHOICE: "multiple_choice",
  DROPDOWN: "dropdown",
  HEADER: "header",
  HEADING: "heading",
  PARAGRAPH: "paragraph",
  FULL_NAME: "full_name",
  EMAIL: "email",
  PHONE: "phone",
  ADDRESS: "address",
  SPACER: "spacer",
  LINE: "line",
  FILE_UPLOAD: "file_upload",
  IMAGE: "image",
  YOUTUBE: "youtube",
  VIMEO: "vimeo",
  COMMUNITY_CONSENT: "community_consent",
  LOYALTY_SIGN_UP: "loyalty_sign_up",
  ACCEPTANCE: "acceptance",
  CONSENT: "consent",
  PRODUCT_ASSOCIATION: "product_association",
  HIDDEN: "hidden",
  SMILEY_SCALE: "smile_scale",
  THUMB_SCALE: "thumb_scale",
  NUMBER_SCALE: "number_scale",
  DATE: "date",
  BIRTHDAY: "birthday",
  SINGLE_MATRIX: "single_matrix",
  MULTIPLE_MATRIX: "multiple_matrix"
};
export const FORM_ELEMENTS_CLASSES = {
  SINGLE_LINE_TEXT: "input input-single",
  NUMBER: "input input-number",
  MULTI_LINE_TEXT: "input input-textarea",
  WEBSITE: "input input-website",
  STAR_RATING: "input input-rating",
  SINGLE_CHOICE: "input input-single-choice",
  MULTIPLE_CHOICE: "input input-multiple-choice",
  DROPDOWN: "input input-dropdown",
  HEADER: "div div-header",
  HEADING: "div div-heading",
  PARAGRAPH: "div div-paragraph",
  FULL_NAME: "input input-name",
  EMAIL: "input input-email",
  PHONE: "input input-phone",
  ADDRESS: "input input-address",
  SPACER: "div div-spacer",
  LINE: "div div-line",
  FILE_UPLOAD: "input input-file",
  IMAGE: "div div-image",
  YOUTUBE: "div div-youtube",
  VIMEO: "div div-vimeo",
  COMMUNITY_CONSENT: "input input-community-consent",
  LOYALTY_SIGN_UP: "input input-loyalty-sign-up",
  ACCEPTANCE: "input input-acceptance",
  CONSENT: "input input-consent",
  PRODUCT_ASSOCIATION: "input input-product-association",
  HIDDEN: "input input-hidden",
  SMILEY_SCALE: "input input-smile-scale",
  THUMB_SCALE: "input input-thumb-scale",
  NUMBER_SCALE: "input input-number-scale",
  DATE: "input input-date",
  BIRTHDAY: "input input-birthday",
  SINGLE_MATRIX: "input input-single-matrix",
  MULTIPLE_MATRIX: "input input-multiple-matrix"
};
export const LAYOUT_ELEMENT_TYPES = {
  SUCCESS_MESSAGE: "success_message",
  SUBMIT_BUTTON: "submit_button",
  NEXT_BUTTON: "next_button",
  PREVIOUS_BUTTON: "previous_button"
};
export const LAYOUT_ELEMENT_CLASSES = {
  SUCCESS_MESSAGE: "div div-success-message",
  SUBMIT_BUTTON: "div div-submit-button",
  NEXT_BUTTON: "div div-primary-button",
  PREVIOUS_BUTTON: "div div-previous-button"
};
export const NODE_NAMES = {
  SELF: "",
  LABEL: "label",
  DIV: "div",
  FIELDSET: "fieldset",
  LEGEND: "legend",
  H1: "h1",
  H2: "h2",
  HR: "hr",
  FIGURE: "figure",
  IMG: "img",
  TEXT: "#text",
  BUTTON: "button",
  INPUT: "input",
  OUTPUT: "output",
  TEXTAREA: "textarea",
  SELECT: "select",
  OPTION: "option",
  P: "p",
  A: "a",
  HGROUP: "hgroup",
  TABLE: "table",
  THEAD: "thead",
  TBODY: "tbody",
  TR: "tr",
  TH: "th",
  TD: "td",
  IFRAME: "iframe"
};
export const TITLE_PROPERTIES = {
  ALT: "alt",
  SRC: "src",
  CONTENT: "content",
  NAME: "name",
  VALUE: "value",
  NODE_VALUE: "nodeValue"
};
export const PEOPLE_WORKFLOW = "people";
export const INPUT_TYPES = {
  TEXT: "text",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  NUMBER: "number",
  DATE: "date",
  URL: "url",
  TEL: "tel",
  EMAIL: "email",
  TEXTAREA: "textarea",
  HIDDEN: "hidden",
  FILE: "file"
};
export const ELEMENTS_ID_PHRASES = {
  [FORM_ELEMENTS_TYPES.SINGLE_LINE_TEXT]: "single_line",
  [FORM_ELEMENTS_TYPES.MULTI_LINE_TEXT]: "multi_line",
  [FORM_ELEMENTS_TYPES.NUMBER]: "number",
  [FORM_ELEMENTS_TYPES.STAR_RATING]: "rating",
  [FORM_ELEMENTS_TYPES.HEADER]: "header",
  [FORM_ELEMENTS_TYPES.HEADING]: "heading",
  [FORM_ELEMENTS_TYPES.FULL_NAME]: {
    FIRST_NAME: "first_name",
    LAST_NAME: "last_name"
  },
  [FORM_ELEMENTS_TYPES.EMAIL]: "email",
  [FORM_ELEMENTS_TYPES.FILE_UPLOAD]: "media",
  [FORM_ELEMENTS_TYPES.CONSENT]: "consent",
  [FORM_ELEMENTS_TYPES.SINGLE_CHOICE]: "single_choice",
  [FORM_ELEMENTS_TYPES.MULTIPLE_CHOICE]: "multiple_choice",
  [FORM_ELEMENTS_TYPES.WEBSITE]: "website",
  [FORM_ELEMENTS_TYPES.IMAGE]: "image",
  [FORM_ELEMENTS_TYPES.YOUTUBE]: "youtube",
  [FORM_ELEMENTS_TYPES.VIMEO]: "vimeo",
  [FORM_ELEMENTS_TYPES.SMILEY_SCALE]: "smiley_scale",
  [FORM_ELEMENTS_TYPES.PHONE]: "phone",
  [FORM_ELEMENTS_TYPES.ADDRESS]: {
    ADDRESS_LINE_1: "address_line_1",
    ADDRESS_LINE_2: "address_line_2",
    ADDRESS_LINE_3: "address_line_3",
    ADDRESS_LEVEL_1: "address_level_1",
    ADDRESS_LEVEL_2: "address_level_2",
    COUNTRY: "country",
    POSTAL_CODE: "postal_code"
  },
  [FORM_ELEMENTS_TYPES.COMMUNITY_CONSENT]: "community_consent",
  [FORM_ELEMENTS_TYPES.LOYALTY_SIGN_UP]: "loyalty_sign_up",
  [FORM_ELEMENTS_TYPES.DROPDOWN]: "dropdown",
  [FORM_ELEMENTS_TYPES.THUMB_SCALE]: "thumb_scale",
  [FORM_ELEMENTS_TYPES.SPACER]: "spacer",
  [FORM_ELEMENTS_TYPES.NUMBER_SCALE]: "number_scale",
  [FORM_ELEMENTS_TYPES.DATE]: "date",
  [FORM_ELEMENTS_TYPES.ACCEPTANCE]: "acceptance",
  [FORM_ELEMENTS_TYPES.BIRTHDAY]: "birthday",
  [FORM_ELEMENTS_TYPES.PRODUCT_ASSOCIATION]: "product_association",
  [FORM_ELEMENTS_TYPES.SINGLE_MATRIX]: "single_matrix",
  [FORM_ELEMENTS_TYPES.MULTIPLE_MATRIX]: "multiple_matrix",
  [FORM_ELEMENTS_TYPES.HIDDEN]: "hidden"
};
export const FORM_BUILDER_ELEMENTS_WITH_COMPLEX_SLUGS = [
  FORM_ELEMENTS_TYPES.STAR_RATING,
  FORM_ELEMENTS_TYPES.SINGLE_CHOICE,
  FORM_ELEMENTS_TYPES.MULTIPLE_CHOICE,
  FORM_ELEMENTS_TYPES.SINGLE_MATRIX,
  FORM_ELEMENTS_TYPES.MULTIPLE_MATRIX,
  FORM_ELEMENTS_TYPES.NUMBER_SCALE,
  FORM_ELEMENTS_TYPES.THUMB_SCALE,
  FORM_ELEMENTS_TYPES.SMILEY_SCALE
];
export const FORM_ELEMENTS_TYPES_TO_CLASSES = {
  [FORM_ELEMENTS_TYPES.SINGLE_LINE_TEXT]: FORM_ELEMENTS_CLASSES.SINGLE_LINE_TEXT,
  [FORM_ELEMENTS_TYPES.MULTI_LINE_TEXT]: FORM_ELEMENTS_CLASSES.MULTI_LINE_TEXT,
  [FORM_ELEMENTS_TYPES.WEBSITE]: FORM_ELEMENTS_CLASSES.WEBSITE,
  [FORM_ELEMENTS_TYPES.STAR_RATING]: FORM_ELEMENTS_CLASSES.STAR_RATING,
  [FORM_ELEMENTS_TYPES.SINGLE_CHOICE]: FORM_ELEMENTS_CLASSES.SINGLE_CHOICE,
  [FORM_ELEMENTS_TYPES.MULTIPLE_CHOICE]: FORM_ELEMENTS_CLASSES.MULTIPLE_CHOICE,
  [FORM_ELEMENTS_TYPES.DROPDOWN]: FORM_ELEMENTS_CLASSES.DROPDOWN,
  [FORM_ELEMENTS_TYPES.HEADER]: FORM_ELEMENTS_CLASSES.HEADER,
  [FORM_ELEMENTS_TYPES.HEADING]: FORM_ELEMENTS_CLASSES.HEADING,
  [FORM_ELEMENTS_TYPES.PARAGRAPH]: FORM_ELEMENTS_CLASSES.PARAGRAPH,
  [FORM_ELEMENTS_TYPES.FULL_NAME]: FORM_ELEMENTS_CLASSES.FULL_NAME,
  [FORM_ELEMENTS_TYPES.EMAIL]: FORM_ELEMENTS_CLASSES.EMAIL,
  [FORM_ELEMENTS_TYPES.PHONE]: FORM_ELEMENTS_CLASSES.PHONE,
  [FORM_ELEMENTS_TYPES.ADDRESS]: FORM_ELEMENTS_CLASSES.ADDRESS,
  [FORM_ELEMENTS_TYPES.SPACER]: FORM_ELEMENTS_CLASSES.SPACER,
  [FORM_ELEMENTS_TYPES.LINE]: FORM_ELEMENTS_CLASSES.LINE,
  [FORM_ELEMENTS_TYPES.FILE_UPLOAD]: FORM_ELEMENTS_CLASSES.FILE_UPLOAD,
  [FORM_ELEMENTS_TYPES.IMAGE]: FORM_ELEMENTS_CLASSES.IMAGE,
  [FORM_ELEMENTS_TYPES.YOUTUBE]: FORM_ELEMENTS_CLASSES.YOUTUBE,
  [FORM_ELEMENTS_TYPES.VIMEO]: FORM_ELEMENTS_CLASSES.VIMEO,
  [FORM_ELEMENTS_TYPES.COMMUNITY_CONSENT]: FORM_ELEMENTS_CLASSES.COMMUNITY_CONSENT,
  [FORM_ELEMENTS_TYPES.LOYALTY_SIGN_UP]: FORM_ELEMENTS_CLASSES.LOYALTY_SIGN_UP,
  [FORM_ELEMENTS_TYPES.ACCEPTANCE]: FORM_ELEMENTS_CLASSES.ACCEPTANCE,
  [FORM_ELEMENTS_TYPES.CONSENT]: FORM_ELEMENTS_CLASSES.CONSENT,
  [FORM_ELEMENTS_TYPES.PRODUCT_ASSOCIATION]: FORM_ELEMENTS_CLASSES.PRODUCT_ASSOCIATION,
  [FORM_ELEMENTS_TYPES.HIDDEN]: FORM_ELEMENTS_CLASSES.HIDDEN,
  [FORM_ELEMENTS_TYPES.SMILEY_SCALE]: FORM_ELEMENTS_CLASSES.SMILEY_SCALE,
  [FORM_ELEMENTS_TYPES.THUMB_SCALE]: FORM_ELEMENTS_CLASSES.THUMB_SCALE,
  [FORM_ELEMENTS_TYPES.NUMBER_SCALE]: FORM_ELEMENTS_CLASSES.NUMBER_SCALE,
  [FORM_ELEMENTS_TYPES.DATE]: FORM_ELEMENTS_CLASSES.DATE,
  [FORM_ELEMENTS_TYPES.BIRTHDAY]: FORM_ELEMENTS_CLASSES.BIRTHDAY,
  [FORM_ELEMENTS_TYPES.NUMBER]: FORM_ELEMENTS_CLASSES.NUMBER,
  [FORM_ELEMENTS_TYPES.SINGLE_MATRIX]: FORM_ELEMENTS_CLASSES.SINGLE_MATRIX,
  [FORM_ELEMENTS_TYPES.MULTIPLE_MATRIX]: FORM_ELEMENTS_CLASSES.MULTIPLE_MATRIX,
  [LAYOUT_ELEMENT_TYPES.SUBMIT_BUTTON]: LAYOUT_ELEMENT_CLASSES.SUBMIT_BUTTON,
  [LAYOUT_ELEMENT_TYPES.SUCCESS_MESSAGE]: LAYOUT_ELEMENT_CLASSES.SUCCESS_MESSAGE,
  [LAYOUT_ELEMENT_TYPES.NEXT_BUTTON]: LAYOUT_ELEMENT_CLASSES.NEXT_BUTTON,
  [LAYOUT_ELEMENT_TYPES.PREVIOUS_BUTTON]: LAYOUT_ELEMENT_CLASSES.PREVIOUS_BUTTON
};
